export default __webpack_public_path__ + "static/media/shourya.6feb6818.png";